import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m18.953 26.399 4.362-4.362a8.224 8.224 0 1 0-11.63 0l4.363 4.362a2.055 2.055 0 0 0 2.905 0Zm1.63-10.176a3.084 3.084 0 1 1-6.167 0 3.084 3.084 0 0 1 6.167 0Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgLocation;